/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsfilterlabel2Inputs */

const en_signupsfilterlabel2 = /** @type {(inputs: Signupsfilterlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter accounts`)
};

const de_signupsfilterlabel2 = /** @type {(inputs: Signupsfilterlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten filtern`)
};

/**
* | output |
* | --- |
* | "Filter accounts" |
*
* @param {Signupsfilterlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsfilterlabel2 = /** @type {((inputs?: Signupsfilterlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsfilterlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsfilterlabel2(inputs)
	return de_signupsfilterlabel2(inputs)
});
export { signupsfilterlabel2 as "signupsFilterLabel" }